module.exports = __webpack_public_path__ + "img/img02.0ca2b464.png";